import React, {useRef, useEffect} from 'react';
import {View, Animated, Easing, StyleSheet} from 'react-native';
import BreaksReimaginedSVG from '../img/svg/BreaksReimaginedSVG';

export default function AramarkAnimationLogo({duration = 2000}) {
  const rotateAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const spin = Animated.sequence([
      Animated.timing(rotateAnim, {
        toValue: 3,
        duration,
        easing: Easing.out(Easing.quad),
        useNativeDriver: true,
      }),
      Animated.delay(100),
    ]);
    const loop = Animated.loop(spin);
    loop.start();

    return () => {
      // stop any running animations and reset value to avoid leaks
      rotateAnim.stopAnimation();
      rotateAnim.setValue(0);
    };
  }, [duration, rotateAnim]);

  const spinInterpolate = rotateAnim.interpolate({
    inputRange: [0, 3],
    outputRange: ['45deg', '1125deg'],
  });

  return (
    <View style={styles.container}>
      <View style={styles.logoWrapper}>
        <View style={[styles.circle, styles.circleOuter]} />
        <View style={[styles.circle, styles.circleInner]} />
        <View style={styles.centered}>
          <Animated.View style={{transform: [{rotate: spinInterpolate}]}}>
            <View style={styles.verticalOuter}>
              <View style={styles.verticalInner} />
            </View>
          </Animated.View>
        </View>
        <View style={styles.svgWrapper}>
          <BreaksReimaginedSVG size={130} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {alignItems: 'center', justifyContent: 'center'},
  logoWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 160,
    height: 160,
  },
  circle: {position: 'absolute', borderWidth: 2},
  circleOuter: {width: 120, height: 120, borderRadius: 70},
  circleInner: {width: 110, height: 110, borderRadius: 55},
  centered: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  verticalOuter: {
    marginTop: -35,
    backgroundColor: '#A3DBE2',
    height: 114,
    width: 6,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
  },
  verticalInner: {
    height: 110,
    width: 2,
    borderRadius: 2,
    backgroundColor: 'black',
  },
  svgWrapper: {
    position: 'absolute',
    top: 55,
    transform: [{rotate: '10deg'}],
    backgroundColor: '#A3DBE2',
  },
});
